export default __webpack_public_path__ + "static/Hellbaby-386c388d51510674846b35bfe5aa3097.png";